<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Change Password</div> 
                    <div class="card-body">
                        <form  @submit.prevent="submit">
                            <div class="form-group row">
                                <label for="current-password" class="col-md-4 col-form-label text-md-right">Current Password</label> 
                                <div class="col-md-6">
                                    <input id="current-password" type="password" name="current_password" v-model="current_password" required="required" autocomplete="current-password" autofocus="autofocus" class="form-control "
                                        :class="{'is-invalid': hasCurrentPasswordError}" >
                                    <form-error name="current_password" :errors="errors"></form-error>
                                </div>
                            </div> 
                            <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">Password</label> 
                                <div class="col-md-6">
                                    <input id="password" type="password" name="password" v-model="password" required="required" autocomplete="new-password" class="form-control "
                                        :class="{'is-invalid': hasPasswordError}" >
                                    <form-error name="password" :errors="errors"></form-error>
                                </div>
                            </div> 
                            <div class="form-group row">
                                <label for="password-confirm" class="col-md-4 col-form-label text-md-right">Password Confirmation</label> 
                                <div class="col-md-6">
                                    <input id="password-confirm" type="password" name="password_confirmation" v-model="password_confirmation" required="required" autocomplete="new-password" class="form-control "
                                        :class="{'is-invalid': hasPasswordError}" >
                                </div>
                            </div> 
                            <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-4">
                                    <button type="submit" class="btn btn-primary">
                                        Reset Password
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormError from "../../Util/FormError";
import UsersService from "../../../services/UsersService";

export default {
    data: function () {
        return {
            current_password: '',
            password: '',
            password_confirmation: '',
            errors: {},
        }
    },

    components: {
        FormError,
    },

    mounted() {
        this.reset();
    },

    methods: {
        submit: function () {
            this.errors = {};

            UsersService.changePassword({ 
                current_password: this.current_password, 
                password: this.password, 
                password_confirmation: this.password_confirmation,
            })
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
        },
        success: function () {
            window.flash('Password Changed');
            this.reset();
            this.$router.push({name: 'profile', params:{id: this.id}});
        },
        failed: function(response){
            this.current_password = this.password = this.password_confirmation = '';
            this.errors = response.data.errors;
        },  
        reset: function () {
            this.current_password = this.password = this.password_confirmation = '';
            this.errors = {};
        }
    },

    computed: {
        hasCurrentPasswordError: function () {
            return (this.errors['current_password']);
        },
        hasPasswordError: function () {
            return (this.errors['password']);
        },
        id: function () {
            return this.$store.state.currentUser.id || null;
        }
    }
}
</script>
